// InstagramReelGrid.jsx
import React from "react";
import InstagramReelCard from "./InstagramReelCard.jsx";
import "../assets/css/OnStage.css";

export default function InstagramReelGrid({ items = [] }) {
  return (
    <div className="igc-grid">
      {items.map((it, i) => (
        <div key={i} className="igc-grid-item">
          <InstagramReelCard {...it} />
        </div>
      ))}
    </div>
  );
}
